import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-action-menu-item',
  template: `
    <button
      type="button"
      class="app-action-menu__item"
      [ngClass]="[
        variant ? 'app-action-menu__item--' + variant : '',
        disabled ? 'app-action-menu__item--disabled' : '',
        customClass
      ]"
      [disabled]="disabled"
      [cdkCopyToClipboard]="copyValue || ''"
      (click)="handleClick($event)"
    >
      <!-- Dynamic / Explicit Icon in Theme Blue -->
      <span *ngIf="resolvedIcon || iconClass || hasCustomIcon" class="app-action-menu__item__icon">
        <!-- Add / Plus -->
        <svg *ngIf="resolvedIcon === 'add'" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 4.16666V15.8333" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.16675 10H15.8334" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <!-- Edit / Modify -->
        <svg *ngIf="resolvedIcon === 'edit'" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 13.3333H15" stroke="#0386ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M12 2.33334C12.2652 2.06813 12.6249 1.91913 13 1.91913C13.1857 1.91913 13.3696 1.95571 13.5412 2.02678C13.7128 2.09785 13.8687 2.20202 14 2.33334C14.1313 2.46466 14.2355 2.62057 14.3066 2.79215C14.3776 2.96373 14.4142 3.14762 14.4142 3.33334C14.4142 3.51906 14.3776 3.70296 14.3066 3.87454C14.2355 4.04612 14.1313 4.20202 14 4.33334L5.66667 12.6667L3 13.3333L3.66667 10.6667L12 2.33334Z" stroke="#0386ff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <!-- Delete / Trash / Forget -->
        <svg *ngIf="resolvedIcon === 'delete'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          <line x1="10" y1="11" x2="10" y2="17"></line>
          <line x1="14" y1="11" x2="14" y2="17"></line>
        </svg>

        <!-- Download / Export PDF -->
        <svg *ngIf="resolvedIcon === 'download'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>

        <!-- Copy / Clipboard -->
        <svg *ngIf="resolvedIcon === 'copy'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
        </svg>

        <!-- Clone / Duplicate -->
        <svg *ngIf="resolvedIcon === 'clone'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="8" width="12" height="12" rx="2"></rect>
          <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path>
        </svg>

        <!-- Customer / User / Profile / Contact -->
        <svg *ngIf="resolvedIcon === 'user'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>

        <!-- View / Details / Eye -->
        <svg *ngIf="resolvedIcon === 'view'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>

        <!-- Send / Mail / Resend -->
        <svg *ngIf="resolvedIcon === 'send'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <path d="M22 12v-6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9" />
          <path d="m22 6-10 7L2 6" />
          <path d="M16 19h6" />
          <path d="m19 16 3 3-3 3" />
        </svg>

        <!-- Print -->
        <svg *ngIf="resolvedIcon === 'print'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <polyline points="6 9 6 2 18 2 18 9"></polyline>
          <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
          <rect x="6" y="14" width="12" height="8"></rect>
        </svg>

        <!-- History / Log -->
        <svg *ngIf="resolvedIcon === 'history'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>

        <!-- Refresh / Reload -->
        <svg *ngIf="resolvedIcon === 'refresh'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <path d="M23 4v6h-6"></path>
          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
        </svg>

        <!-- Check / Approve -->
        <svg *ngIf="resolvedIcon === 'check'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>

        <!-- Close / Reject -->
        <svg *ngIf="resolvedIcon === 'close'" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0386ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>

        <!-- Custom Icon Class or Image URL -->
        <i *ngIf="iconClass" [class]="iconClass"></i>
        <img *ngIf="isImageSource" [src]="icon" alt="" />
        
        <!-- Projected Custom Icon Slot -->
        <ng-content select="[icon]"></ng-content>
      </span>

      <span #labelRef class="app-action-menu__item__label">
        <ng-content></ng-content>
      </span>
    </button>
  `,
  styleUrls: ['./app-action-menu.component.scss'],
})
export class AppActionMenuItemComponent {
  @ViewChild('labelRef', { static: false }) labelRef?: ElementRef;

  @Input() icon: string = '';
  @Input() iconClass: string = '';
  @Input() disabled: boolean = false;
  @Input() variant: 'default' | 'primary' | 'danger' = 'default';
  @Input() copyValue: string = '';
  @Input() customClass: string = '';

  @Output() clicked = new EventEmitter<MouseEvent>();

  get isImageSource(): boolean {
    return !!this.icon && (this.icon.includes('/') || this.icon.includes('.'));
  }

  get hasCustomIcon(): boolean {
    return !!this.iconClass || this.isImageSource;
  }

  get resolvedIcon(): string {
    if (this.icon) {
      const lower = this.icon.toLowerCase().trim();
      if (lower === 'add' || lower === 'plus' || lower === 'create' || lower === 'new') return 'add';
      if (lower === 'edit' || lower === 'pencil' || lower === 'modify') return 'edit';
      if (lower === 'delete' || lower === 'trash' || lower === 'remove' || lower === 'forget') return 'delete';
      if (lower === 'download' || lower === 'pdf' || lower === 'export') return 'download';
      if (lower === 'copy' || lower === 'clipboard') return 'copy';
      if (lower === 'clone' || lower === 'duplicate') return 'clone';
      if (lower === 'user' || lower === 'customer' || lower === 'profile' || lower === 'contact') return 'user';
      if (lower === 'view' || lower === 'eye' || lower === 'preview' || lower === 'details') return 'view';
      if (lower === 'send' || lower === 'mail' || lower === 'email' || lower === 'resend') return 'send';
      if (lower === 'print') return 'print';
      if (lower === 'history' || lower === 'log' || lower === 'audit') return 'history';
      if (lower === 'refresh' || lower === 'sync' || lower === 'reload') return 'refresh';
      if (lower === 'check' || lower === 'approve' || lower === 'verify' || lower === 'accept') return 'check';
      if (lower === 'close' || lower === 'reject' || lower === 'cancel' || lower === 'decline') return 'close';
      if (!this.isImageSource && !this.iconClass) return lower;
    }

    // Dynamic resolution from projected text
    const text = (this.labelRef?.nativeElement?.textContent || '').trim().toLowerCase();
    if (!text) return '';

    if (text.includes('add') || text.includes('create') || text.includes('new') || text.includes('record')) return 'add';
    if (text.includes('edit') || text.includes('modify') || text.includes('update')) return 'edit';
    if (text.includes('delete') || text.includes('remove') || text.includes('trash') || text.includes('forget')) return 'delete';
    if (text.includes('download') || text.includes('pdf') || text.includes('export')) return 'download';
    if (text.includes('copy') || text.includes('clipboard')) return 'copy';
    if (text.includes('clone') || text.includes('duplicate')) return 'clone';
    if (text.includes('customer') || text.includes('user') || text.includes('profile') || text.includes('contact')) return 'user';
    if (text.includes('view') || text.includes('preview') || text.includes('detail')) return 'view';
    if (text.includes('send') || text.includes('mail') || text.includes('email') || text.includes('resend')) return 'send';
    if (text.includes('print')) return 'print';
    if (text.includes('history') || text.includes('audit') || text.includes('log') || text.includes('activity')) return 'history';
    if (text.includes('refresh') || text.includes('sync') || text.includes('reload')) return 'refresh';
    if (text.includes('approve') || text.includes('verify') || text.includes('accept')) return 'check';
    if (text.includes('reject') || text.includes('cancel') || text.includes('decline')) return 'close';

    return '';
  }

  handleClick(event: MouseEvent): void {
    if (this.disabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    this.clicked.emit(event);
  }
}
